export const ACTIONS_LABELS = {
	CANCEL: 'Cancel',
	SAVE: 'Save',
	SAVE_AND_CRAWL: 'Save & Crawl'
} as const;
